<div class="variants-drink-recomendation-container">
    <div class="variants-drink-recomendation-background" [ngStyle]="{
            'width': 'calc(' + (100 / (drink?.variants?.length || 1)) + '%)',
            'transform': 'translateX(calc(' + (choise * 100) + '%))'
        }"></div>

    <ng-container *ngFor="let item of drink?.variants; let i = index">
        <input type="radio" [id]="'variant-recomendation' + i" name="variants-drink-recomendation" class="variants-drink-recomendation-input" [value]="i"
            [(ngModel)]="choise" (change)="onRecomendationChoiseClick(); $event.stopPropagation()">
        <label [for]="'variant-recomendation' + i" class="variants-drink-recomendation-label">{{ item.title }}</label>
    </ng-container>
</div>